<template>
  <section>
    <v-container fluid text-xs-center style="padding:0;">
      <v-layout row wrap>
        <v-flex xs4 sm4 md4 v-for="(icon, i) in sociais" :key="i">
          <v-btn depressed :color="icon.color" large dark block :href="icon.link">
            <table>
              <tr>
                <td>
                  <div class="bola" style>
                    <img :src="icon.img">
                  </div>
                </td>
              </tr>
              <tr>
                <td
                  style="vertical-align:bottom; font-size:22px; line-height:1em; padding-top:10px;"
                >
                  <div class="font-weight-light texto1">{{icon.text1}}</div>
                  <div class="font-weight-bold texto2">{{icon.text2}}</div>
                  <div class="font-weight-light texto3">{{icon.text3}}</div>
                </td>
              </tr>
            </table>
            <div></div>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
  </section>
</template>

<script>
export default {
  data: () => ({
    sociais: [
      {
        fa: "fas fa-chess-pawn",
        img: "/images/seg1.svg",
        link: "/segmentos/educacao-infantil",
        text1: "Educação",
        text2: "Infantil",
        text3:"de 2 a 5 anos",
        color: "blue darken-1"
      },
      {
        fa: "fas fa-chess-bishop",
        img: "/images/seg2.svg",
        link: "/segmentos/ensino-fundamental-1",
        text1: "Ensino",
        text2: "Fundamental I",
        text3:"do 1º ao 5º ano",
        color: "blue darken-2"
      },
      {
        fa: "fas fa-chess-rook",
        img: "/images/seg3.svg",
        link: "/segmentos/ensino-fundamental-2",
        text1: "Ensino",
        text2: "Fundamental II",
        text3:"do 6º ao 9º ano",
        color: "blue darken-3"
      }
    ]
  })
};
</script>

<style lang="scss" scoped>
section {
  border-top: 5px solid #eee;
  /* border-bottom: 5px solid #eee; */
}
.v-btn {
  padding-top: 90px;
  padding-bottom: 90px;
  margin: 0;
  border-radius: 0;
  .bola {
    background: #eee;
    width: 150px;
    height: 150px;
    border-radius: 50%;
    border: 5px solid #eee;
    margin: -110px auto 0 auto;
    img {
      height: 100px;
      margin-top: 25px;
    }
    &:hover {
      background: #fff;
    }
  }
  .texto1,
  texto2 {
    line-height: 1.2em;
  }
  .texto1 {
    font-size: 28px;
  }
  .texto2 {
    font-size: 28px;
  }
  .texto3 {
    font-size: 14px;
  }
}
// XS
@media screen and (max-width: 600px) {
  .v-btn {
    padding-top: 80px;
    padding-bottom: 60px;
    .bola {
      width: 100px;
      height: 100px;
      margin: -115px auto 0 auto;
      img {
        height: 65px;
        margin-top: 12px;
      }
    }
    .texto1,
    texto2 {
      line-height: 1.2em;
    }
    .texto1 {
      font-size: 16px;
    }
    .texto2 {
      font-size: 14px;
    }
  }
}

// SM
@media screen and (max-width: 960px) and (min-width: 601px) {
  .v-btn {
    padding-top: 80px;
    padding-bottom: 70px;
    .bola {
      width: 130px;
      height: 130px;
      margin: -115px auto 0 auto;
      img {
        height: 90px;
        margin-top: 12px;
      }
    }
    .texto1,
    texto2 {
      line-height: 1.2em;
    }
    .texto1 {
      font-size: 22px;
    }
    .texto2 {
      font-size: 20px;
    }
  }
}

// MD
@media screen and (max-width: 1264px) and (min-width: 961px) {
  .v-btn {
    padding-top: 80px;
    padding-bottom: 70px;
    .bola {
      width: 130px;
      height: 130px;
      margin: -115px auto 0 auto;
      img {
        height: 85px;
        margin-top: 12px;
      }
    }
    .texto1,
    texto2 {
      line-height: 1.2em;
    }
    .texto1 {
      font-size: 25px;
    }
    .texto2 {
      font-size: 23px;
    }
  }
}

// LG
@media screen and (max-width: 1904px) and (min-width: 1265px) {
}

// XL
@media screen and (min-width: 1905px) {
}

/* SHAKE EFFECT */
.v-btn:hover img {
  animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  transform: translate3d(0, 0, 0);
  backface-visibility: hidden;
  perspective: 1000px;
}

@keyframes shake {
  10%,
  90% {
    transform: translate3d(-1px, 0, 0);
  }

  20%,
  80% {
    transform: translate3d(2px, 0, 0);
  }

  30%,
  50%,
  70% {
    transform: translate3d(-4px, 0, 0);
  }

  40%,
  60% {
    transform: translate3d(4px, 0, 0);
  }
}
</style>
